import { Typography } from '@mui/material'
import { useRecordContext } from 'react-admin'
import { CSRTitleProps } from './type'

export const CSRTitle: React.FC<CSRTitleProps> = ({ source, ...props }) => {
  const record = useRecordContext()
  return (
    <Typography variant='h3' {...props}>
      {record[source]}
    </Typography>
  )
}
